<div class="ticket old" *ngFor="let i of [0, 1, 2, 3, 4, 5]">
  <ion-row>
    <ion-col size="9" class="body">
      <ion-item lines="full">
        <ion-img class="photo">
          <ion-skeleton-text animated></ion-skeleton-text>
        </ion-img>
        <ion-label>
          <ion-skeleton-text animated style="width: 50%"></ion-skeleton-text>
          <ion-skeleton-text animated style="width: 20%"></ion-skeleton-text>
        </ion-label>
      </ion-item>
      <ion-row>
        <ion-col>
          <ion-skeleton-text animated style="width: 20%"></ion-skeleton-text>
          <ion-skeleton-text animated style="width: 40%"></ion-skeleton-text>
        </ion-col>
        <ion-col size="2">
          <h3>&nbsp;</h3>
        </ion-col>
        <ion-col>
          <h3>&nbsp;</h3>
          <ion-skeleton-text animated style="width: 40%"></ion-skeleton-text>
        </ion-col>
      </ion-row>
    </ion-col>
    <ion-col size="3" class="coupon"></ion-col>
  </ion-row>
</div>
